import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbsencePlanerTimeframeEnum } from '../../enums/absence-planer-timeframe.enum';
import { TimeFrameModel } from '../../models/absence-planer/time-frame.model';
import { DateRange } from '../../models/date-range';
import {
  AbsenceConfirmationItem,
  AbsencePlanerUserList,
  CalendarItem,
  VisumCheck,
} from '../../models/client-models';

export interface AbsencePlanerState {
  users: AbsencePlanerUserList[];
  calendarItems: CalendarItem[];
  allRequests: boolean;
  grouping: number;
  filter: number;
  filterID: number;
  selectedTimeFrame: TimeFrameModel;
  visibleDateRange: DateRange;
  selectedDateRange: DateRange;
  selectedResource: AbsencePlanerUserList;
  selectedDateVisumInfo: VisumCheck;
  requestedAbsences: AbsenceConfirmationItem[];
}

export function createInitialState(): AbsencePlanerState {
  return {
    users: [],
    allRequests: false,
    calendarItems: [],
    grouping: 0,
    filter: 0,
    filterID: 0,
    selectedTimeFrame: AbsencePlanerTimeframeEnum.month,
    visibleDateRange: {} as DateRange,
    selectedDateRange: {} as DateRange,
    selectedResource: {} as AbsencePlanerUserList,
    selectedDateVisumInfo: {
      hasVisum: false,
      visumRemoveable: false,
    } as VisumCheck,
    requestedAbsences: [],
  };
}

@Injectable({
  providedIn: 'root',
})
@StoreConfig({ name: 'absence-planer' })
export class AbsencePlanerStore extends Store<AbsencePlanerState> {
  constructor() {
    super(createInitialState());
  }
}
